// document.title = "交易记录";
import { defineComponent, ref } from "vue";
import { showLoadingToast, closeToast } from "vant";
import { getConsumeLog } from "@/api/my";
export default defineComponent({
  name: "ConsumeLog",
  setup() {
    // 返回按钮
    // const onClickLeft = () => history.back();
    // 查询列表参数
    let queryParams = {
      pageNum: 1,
      pageSize: 20
    };
    // : {
    //   businessMethod: string;
    //   addressName?: string;
    //   businessType: string;
    //   amount: number;
    //   businessTime: string;
    //   amountTotal: number;
    // }[]
    let list = ref([]);
    let total;
    // type bool : 是否需要拼接数据
    const getList = async type => {
      showLoadingToast({
        message: "加载中...",
        forbidClick: true
      });
      try {
        const {
          code,
          rows,
          total: sum
        } = await getConsumeLog(queryParams);
        if (code === 200) {
          list.value = !type ? rows : list.value.concat(rows);
          total = sum;
        }
        closeToast();
      } catch (error) {
        closeToast();
      }
    };
    // 下拉刷新
    const refreshing = ref(false); // 下拉刷新loading
    const onRefresh = async () => {
      console.log("onRefresh");
      queryParams.pageNum = 1;
      await getList(false);
      finished.value = false;
      refreshing.value = false;
    };
    // 上拉加载
    const loading = ref(false); // 上拉加载loading
    const finished = ref(false); // 是否已经加载完成
    const onLoad = async () => {
      // 查询条数 * 查询页码 >= 总条数
      if (queryParams.pageNum * queryParams.pageSize >= total) {
        finished.value = true;
        loading.value = false;
        return;
      }
      queryParams.pageNum = ++queryParams.pageNum;
      await getList(true);
      loading.value = false;
    };
    onRefresh();
    return {
      // onClickLeft,
      list,
      refreshing,
      onRefresh,
      loading,
      finished,
      onLoad
    };
  }
});